import React from 'react'

interface MapIconProps {
  className?: string;
}

const MapIcon: React.FC<MapIconProps> = ({ className }) => {
  return (


<svg width="24" height="24" className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M5 9C5 8.08075 5.18106 7.1705 5.53284 6.32122C5.88463 5.47194 6.40024 4.70026 7.05025 4.05025C7.70026 3.40024 8.47194 2.88463 9.32122 2.53284C10.1705 2.18106 11.0807 2 12 2C12.9193 2 13.8295 2.18106 14.6788 2.53284C15.5281 2.88463 16.2997 3.40024 16.9497 4.05025C17.5998 4.70026 18.1154 5.47194 18.4672 6.32122C18.8189 7.1705 19 8.08075 19 9C19 14.25 12 22 12 22C12 22 5 14.25 5 9ZM9.5 9C9.5 9.66304 9.76339 10.2989 10.2322 10.7678C10.7011 11.2366 11.337 11.5 12 11.5C12.663 11.5 13.2989 11.2366 13.7678 10.7678C14.2366 10.2989 14.5 9.66304 14.5 9C14.5 8.33696 14.2366 7.70107 13.7678 7.23223C13.2989 6.76339 12.663 6.5 12 6.5C11.337 6.5 10.7011 6.76339 10.2322 7.23223C9.76339 7.70107 9.5 8.33696 9.5 9Z" fill="#1E293B"/>
</svg>

  )
}

export default MapIcon

